import { render } from "./FooTer.vue?vue&type=template&id=7035fb97&scoped=true"
import script from "./FooTer.vue?vue&type=script&lang=js"
export * from "./FooTer.vue?vue&type=script&lang=js"

import "./FooTer.vue?vue&type=style&index=0&id=7035fb97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7035fb97"]])

export default __exports__